// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export const statusCardDefaults = {
  statusColor: 'red',
  title: 'Status Card',
  toolTipText: 'Needs Attention',
};
